import {
	CreateDrawerFormProps,
	DateTimeField,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	PagedSingleSelectField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { ActivityOptionDto, ProjectOptionDto } from "apiGen";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { activityKeys } from "~shared/api/activities/activityKeys";
import { projectKeys } from "~shared/api/projects/projectKeys";
import { timeKeys } from "~shared/api/times/timeKeys";
import { webserviceApi } from "~shared/api/webserviceApi";

export interface TimeFormState {
	start: string;
	end?: string | null;
	activity: ActivityOptionDto | null;
	project: ProjectOptionDto | null;
}

const useValidate = () => {
	const { t } = useTranslation();

	return (values: TimeFormState) => {
		const errors: { [K in keyof TimeFormState]?: any } = {};

		if (!values.activity) {
			errors.activity = t("Required field");
		}
		if (!values.project) {
			errors.project = t("Required field");
		}
		return errors;
	};
};

const OwnTimeDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<DateTimeField name="start" label={t("Start")} />
			<DateTimeField name="end" label={t("End")} />
			<PagedSingleSelectField<ProjectOptionDto>
				name="project"
				label={t("Project")}
				fetcher={(search, page) => webserviceApi.listProjectOptions(search, page).then((x) => x.data)}
				queryKey={[...projectKeys.lists()]}
				getLabel={(x) => x.name}
			/>
			<PagedSingleSelectField<ActivityOptionDto>
				name="activity"
				label={t("Activity")}
				fetcher={(search, page) => webserviceApi.listActivityOptions(search, page).then((x) => x.data)}
				queryKey={[...activityKeys.options()]}
				getLabel={(x) => x.name}
			/>
		</FormDrawerContent>
	);
};

export const OwnTimeCreateDrawer: FC<CreateDrawerFormProps<TimeFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: TimeFormState = {
		start: new Date().toISOString(),
		end: null,
		activity: null,
		project: null,
	};

	return (
		<FormDrawer
			{...drawerProps}
			initialValues={initialValues}
			validate={validate}
			title={t("Create time")}
			renderForm={(props) => <OwnTimeDrawerContent {...props} />}
		/>
	);
};

export const OwnTimeUpdateDrawer: FC<UpdateDrawerFormProps<TimeFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			validate={validate}
			title={t("Edit time")}
			queryFn={() => webserviceApi.showTime(+drawerProps.id).then((x) => x.data.data)}
			queryKey={timeKeys.detail(drawerProps.id)}
			renderSuccess={(props) => <OwnTimeDrawerContent {...props} />}
		/>
	);
};
